import { render, staticRenderFns } from "./tab-bar-slot.mpx?vue&type=template&id=23854a6a&isComponent&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex"
import script from "./tab-bar-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex"
export * from "./tab-bar-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports